export const FEATURED = 'FEATURED';
export const GENERATE = 'GENERATE';
export const SUMMARIZE = 'SUMMARIZE';
export const RESEARCH = 'RESEARCH';
export const ADD_AN_OBJECT = 'ADD_AN_OBJECT';
export const HUBSPOT_HOW_TO = 'HUBSPOT_HOW_TO';
export const PREPARE = 'PREPARE';
export const TEMPLATE_GROUPINGS = {
  [GENERATE]: ['generate_knowledge_base_articles', 'freeform_images', 'blog_generator', 'modify_content_length', 'lead_reactivation__email', 'sales_email_to_thought_leader', 'initial_outreach_email', 'draft_personalized_initial_outreach_email'],
  [SUMMARIZE]: ['summarize_company', 'summarize_contact', 'show_engagements_with_company', 'summary_reporting', 'show_engagements_with_contact', 'object_count'],
  [RESEARCH]: ['company_profile', 'news', 'competitors', 'technology_used'],
  [ADD_AN_OBJECT]: ['add_company', 'add_contact', 'add_deal', 'add_note_to_contact', 'add_ticket'],
  [HUBSPOT_HOW_TO]: ['knowledgebase_search', 'app_finder', 'ask_hubspot_academy'],
  [PREPARE]: ['prepare_for_a_meeting_with_a_company', 'prepare_for_a_meeting_with_a_contact']
};
export const TEMPLATE_CATEGORIES = {
  [FEATURED]: {
    iconName: 'location',
    title: 'aiComponentsUiLibrary.components.prompts.promptTemplates.categories.featured.title',
    use: 'tertiary-light'
  },
  [GENERATE]: {
    iconName: 'insertImage',
    title: 'aiComponentsUiLibrary.components.prompts.promptTemplates.categories.generate.title'
  },
  [SUMMARIZE]: {
    iconName: 'bulletDiamond',
    title: 'aiComponentsUiLibrary.components.prompts.promptTemplates.categories.summarize.title'
  },
  [RESEARCH]: {
    iconName: 'companies',
    title: 'aiComponentsUiLibrary.components.prompts.promptTemplates.categories.research.title'
  },
  [ADD_AN_OBJECT]: {
    iconName: 'table',
    title: 'aiComponentsUiLibrary.components.prompts.promptTemplates.categories.addAnObject.title'
  },
  [HUBSPOT_HOW_TO]: {
    iconName: 'sprocket',
    title: 'aiComponentsUiLibrary.components.prompts.promptTemplates.categories.hubspotHowTo.title'
  },
  [PREPARE]: {
    iconName: 'meetings',
    title: 'aiComponentsUiLibrary.components.prompts.promptTemplates.categories.prepare.title'
  }
};